
export enum AssetWheelchairRamp {
  Electric= 'Electric',
  Manual= 'Manual',
  Electropneumatic= 'Electropneumatic',
  Absent= 'Absent',

}